export default "__VITE_ASSET__BMJP65sq__"